import cognitoService from "@/services/cognitoService";
import { useUserStore } from "@/stores/userStore";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, message, Result } from "antd";
import ImpersonationBar from "@/layout/ImpersonationBar";

/**
 * Error component displayed when user has no associated companies
 * Prevents access to dashboard and instructs user to contact administrator
 * Shows ImpersonationBar when super admin is impersonating a user with no companies
 */
const NoCompanyError: React.FC = () => {
  const logout = useUserStore((state) => state.logout);
  const isImpersonating = useUserStore((state) => !!state.superAdminStore || !!state.adminStore);

  const handleLogout = () => {
    // Clear local state first
    logout();

    // Logout from cognito and redirect to login
    cognitoService.logout().catch((err) => {
      console.error("Logout failed:", err);
      message.error("Failed to logout. Please try again.");
    });
  };

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Show impersonation bar so super admin can exit even when user has no companies */}
      {isImpersonating && <ImpersonationBar />}
      <div className="flex-1 flex items-center justify-center">
        <Result
          icon={<ExclamationCircleOutlined style={{ color: "#faad14" }} />}
          status="warning"
          title="No Company Associated"
          subTitle="You are not associated with any company. Please contact your administrator to assign a company to your account."
          extra={
            isImpersonating ? null : (
              <Button
                type="primary"
                key="logout"
                onClick={handleLogout}
                style={{
                  backgroundColor: "#3b82f6",
                  borderColor: "#3b82f6",
                }}
              >
                Back to Login
              </Button>
            )
          }
        />
      </div>
    </div>
  );
};

export default NoCompanyError;
